// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7069fe7f","239":"8bc28d34","667":"41cd1950","722":"feba2ef0","726":"9fb8d723"}[chunkId] + ".chunk.js";
};